import React from 'react'

type Step = 
    "step_1_generate_master_key" | 
    "step_2_register_mpk" |
    "step_3_register_master_key" |
    "step_5_request_IDT" | 
    "step_6_proof_of_possession" | 
    "step_6_blinded_claims" | 
    "step_6_unblinded_claims" |
    "step_6_generate_proof_key" 

interface StepHeaderProps {
    step: Step
}

const headerData = (step: Step) => {
    var title, desc,subtitle = ""
    switch (step) {
        case "step_1_generate_master_key":
            title = "Generate Your Master Public Key";
            desc = "Your digital wallet creates a unique Master Public Key (MPK), which Authorization Servers use to derive Proof-of-Possession keys for secure interactions.";
          break;
        case "step_2_register_mpk":
            title = "Register Your MPK With an Authorization Server";
            desc = "MPK registration is a one-time process that enables secure key derivation by the Authorization Server.";
          break;
        case "step_3_register_master_key":
            title = "Why Register Your Master Public Key?";
            desc = "Registering your MPK is similar to OAuth client registration for the Private Key JWT authentication method. By registering, the Authorization Server can securely derive public keys while ensuring your private keys remain confidential to your wallet. This one-time process enables seamless IDT++ issuance, and your MPK can be shared through any communication channel.";
          break;
      
        case "step_5_request_IDT":
            title = "Request Your IDT++";
            desc = "With your MPK registered, you can request IDT++ tokens, which serve as secure identity credentials.";
        break;


        case "step_6_blinded_claims":
            subtitle = "Blinded Claims";
            desc = "For added privacy, certain claims in your IDT++ tokens are blinded by the Authorization Server using advanced cryptographic techniques: ECDH (Elliptic-Curve Diffie-Hellman) derives encryption/decryption keys. ChaCha20 encrypts the claims for secure handling. Only your wallet or the Authorization Server can unblind these claims, ensuring data privacy.";
        break;

        case "step_6_unblinded_claims":
            subtitle = "Unblinded Claims";
            desc = "The Authorization Server also blinds certain claims. We use a combination of ECDH (Elliptic-Curve Diffie-Hellman) for key derivation and ChaCha20 symmetric encryption to encrypt the claims. Claims can be unblinded independently only by the Authorization Server and your wallet.";
        break;

        case "step_6_proof_of_possession":
            subtitle = "Proof of Possession Key";
            desc = "Every IDT++ token is paired with a unique Proof-of-Possession key derived from your static Master Public Key. This ensures: Only your wallet can generate the secret keys linked to the Proof-of-Possession keys. IDT++ tokens are easy to import and manage within your wallet. Only your wallet can disclose the blinded clams.";
        break;
        case "step_6_generate_proof_key":
            title = "Generate Key - Proof of Possession";
            desc = "Your wallet can prove ownership of the secret key corresponding to the Proof-of-Possession public key.";
        break;

        }
    return {title, desc, subtitle}
}

export const StepHeader = (props:StepHeaderProps) => {
    const data = headerData(props.step)

    return (
        <div>
            <h2 className='text-primary-800 font-poppins font-bold text-3xl leading-[45px]'>{data.title}</h2>
            {/*<div className='text-gray-600'>{data.desc}</div>*/}
        </div>
    )
}


export  const StepSubheader = (props:StepHeaderProps) => {
    const data = headerData(props.step)

    return (
        <div>
            <p className='text-primary-800 font-poppins font-bold text-xl leading-[30px]'>{data.subtitle}</p>
        </div>
    )
}


export  const StepDesc = (props:StepHeaderProps) => {
    const data = headerData(props.step)

    return (
        <div>
            <p className='text-gray-500 leading-loose text-base font-normal'>{data.desc}</p>
        </div>
    )
}

